"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WidgetStrategy = void 0;
var createIframe = function createIframe(widget) {
  var connector = document.createElement("iframe");
  connector.src = widget;
  connector.style.border = "none";
  connector.style.zIndex = "10000";
  connector.style.position = "fixed";
  connector.style.display = "none";
  connector.style.top = "0";
  connector.style.left = "0";
  connector.style.width = "100%";
  connector.style.height = "100%";
  document.body.appendChild(connector);
  return connector;
};
var WidgetStrategy = /*#__PURE__*/function () {
  function WidgetStrategy() {
    var widget = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "https://my.herewallet.app/connector/index.html";
    _classCallCheck(this, WidgetStrategy);
    this.widget = widget;
    if (WidgetStrategy.connector == null) {
      WidgetStrategy.connector = createIframe(widget);
      WidgetStrategy.connector.addEventListener("load", function () {
        WidgetStrategy.isLoaded = true;
      });
    }
  }
  _createClass(WidgetStrategy, [{
    key: "onRequested",
    value: function onRequested(id, request, reject) {
      var _this = this;
      if (WidgetStrategy.connector == null) return;
      WidgetStrategy.connector.style.display = "block";
      var loadHandler = function loadHandler() {
        var _a, _b, _c;
        (_a = WidgetStrategy.connector) === null || _a === void 0 ? void 0 : _a.removeEventListener("load", loadHandler);
        (_c = (_b = WidgetStrategy.connector) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 ? void 0 : _c.postMessage(JSON.stringify({
          type: "request",
          payload: {
            id: id,
            request: request
          }
        }), new URL(_this.widget).origin);
      };
      if (WidgetStrategy.isLoaded) loadHandler();else WidgetStrategy.connector.addEventListener("load", loadHandler);
      this.messageHandler = function (event) {
        try {
          if (event.origin !== new URL(_this.widget).origin) return;
          if (JSON.parse(event.data).type === "reject") reject();
        } catch (_a) {}
      };
      window.addEventListener("message", this.messageHandler);
    }
  }, {
    key: "onApproving",
    value: function onApproving() {
      var _a;
      if (WidgetStrategy.connector == null) return;
      (_a = WidgetStrategy.connector.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({
        type: "approving"
      }), new URL(this.widget).origin);
    }
  }, {
    key: "onSuccess",
    value: function onSuccess() {
      this.close();
    }
  }, {
    key: "onFailed",
    value: function onFailed() {
      this.close();
    }
  }, {
    key: "close",
    value: function close() {
      if (this.messageHandler) {
        window.removeEventListener("message", this.messageHandler);
        this.messageHandler = undefined;
      }
      if (WidgetStrategy.connector != null) {
        WidgetStrategy.connector.style.display = "none";
      }
    }
  }]);
  return WidgetStrategy;
}();
exports.WidgetStrategy = WidgetStrategy;
WidgetStrategy.isLoaded = false;